module.exports = __webpack_public_path__ + "img/Logo.7d4760de.png";